// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__gMsgh","header":"Dashboard_header__rwEn1","section":"Dashboard_section__3iSn1","comingSoonCard":"Dashboard_comingSoonCard__GeG0q"};